import { render, staticRenderFns } from "./LabelOTA.vue?vue&type=template&id=62834e9c&scoped=true&"
import script from "./LabelOTA.vue?vue&type=script&lang=js&"
export * from "./LabelOTA.vue?vue&type=script&lang=js&"
import style0 from "./LabelOTA.vue?vue&type=style&index=0&id=62834e9c&scoped=true&lang=css&"
import style1 from "./LabelOTA.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62834e9c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDialog,VPagination,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62834e9c')) {
      api.createRecord('62834e9c', component.options)
    } else {
      api.reload('62834e9c', component.options)
    }
    module.hot.accept("./LabelOTA.vue?vue&type=template&id=62834e9c&scoped=true&", function () {
      api.rerender('62834e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Firmware/LabelOTA.vue"
export default component.exports